import errorIllustration from "../assets/images/error-illustration.png";

export default function ErrorFallback() {
  return (
    <div className="min-h-screen w-full bg-white flex items-center justify-center px-6">
      <div className="max-w-xl w-full text-center">
        <h1 className="text-[28px] font-bold text-[#000000]">
          Something Went Wrong
        </h1>

        <img
          src={errorIllustration}
          alt="Error illustration"
          draggable={false}
          loading="lazy"
          className="mx-auto mt-6 w-40 md:w-60 select-none pointer-events-none"
        />
        <p className="mt-2 text-center font-small text-[14px] text-[#000000]">
          We&apos;re sorry, but an unexpected error has occurred.
          <br />
          Please try refreshing the page or come back later.
        </p>
        <div className="mt-6 flex items-center justify-center gap-3">
          <button
            onClick={() => globalThis.location?.reload()}
            className="inline-flex items-center justify-center rounded-md border border-[#D1D5DB] bg-white px-4 py-2 text-[14px] font-semibold text-[#111827] hover:bg-[#F9FAFB]"
          >
            TRY AGAIN
          </button>
        </div>
      </div>
    </div>
  );
}
